import { Modal, TextField, Typography, Link, Button } from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import Gradient from "../Buttons/Gradient";
import SocialShareComponent from "./socialShareReferral";
import ReCAPTCHA from "react-google-recaptcha";
import { MdOutlineClose } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
const recaptchaRef = React.createRef();
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import fetcher from "../../src/dataProvider";

const useStyles = makeStyles((theme) => ({
  divStyle: {
    textAlign: "center",
  },
  input: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  btnStyle: {
    all: "unset",
    display: "inline-block",
    textTransform: "capitalize !important",
    fontSize: "16px",
    fontWeight: "600 !important",
    fontFamily: "Inter",
    fontStyle: "normal",
    width: "100%",
    maxWidth: "346px",
    height: "auto !important",
    flexDirection: "row",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    backgroundColor: "#E33F84",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    color: "#FFFFFF",
    lineHeight: "36px",
    borderRadius: "12px",
    padding: "10px 0 !important",
    cursor: "pointer",
    lineHeight: "56px",
    textAlign: "center",
    margin: "0",
    textDecoration: "none",
  },
  heading: {
    position: "relative",
    width: "166px",
    height: "34px",
    margin: "46px 0px 0px 332px",
  },
  waitListRank: {
    position: "absolute",
    textAlign: "center",
    width: "266px",
    height: "34px",
    left: "263px",
    top: "84px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "34px",
    color: "black",
    textTransform: "capitalize",
  },
  description: {
    position: "relative",
    width: "631px",
    height: "19px",
    margin: "16px 0px 0px 99.5px",
    textAlign: "center",
  },
  flatline: {
    position: "absolute",
    width: "403px",
    top: "208px",
    left: "205px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
  paper: {
    position: "absolute",
    color: "rgba(0, 0, 0, 1)",
    top: "24px",
    left: "768px",
    right: "28.62px",
    bottom: "610px",
  },
  textField: {
    position: "relative",
    margin: "40px 0px 0px 115px",
    width: "583px",
    height: "56px",
    borderRadius: "12px",
    background: "#FFFFFF",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    fontStyle: "normal",
    lineHeight: "19px",
    color: "rgba(0, 0, 0, 0.54)",
  },
  mobileTextField: {
    position: "relative",
    margin: "25px 0px 0px 115px",
    width: "583px",
    height: "56px",
    borderRadius: "12px",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    fontStyle: "normal",
    lineHeight: "19px",
    color: "rgba(0, 0, 0, 0.54)",
  },
  conditonPara: {
    position: "relative",
    width: "575px",
    height: "42px",
    margin: "10px 0px 0px 119px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.54)",
  },
  termscondition: {
    color: "red",
  },
  signbtn: {
    position: "relative",
    width: "360px",
    height: "56px",
    borderRadius: "16px",
  },
  refInfo: {
    position: "absolute",
    width: "631px",
    heightL: "22px",
    left: "108px",
    top: "236px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "22px",
    marginTop: "10px",
    textAlign: "center",
    fontFeatureSettings: "'cpsp' on",
    color: "rgba(0, 0, 0, 0.75)",
  },
}));

const style = {
  position: "absolute",
  marginTop: "36px",
  marginLeft: "19.6rem",
  width: "812px",
  height: "auto",
  padding: "20px",
  background: "#FFF",
  borderRadius: "20px",
  color: "white",
  boxShadow: 24,
  p: 4,
  padding: "0",
};

const styles = {
  headingText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "34px",
    color: "black",
    textTransform: "capitalize",
  },
  descriptionText: {
    fontFamily: "Inter",
    fontstyle: "normal",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "19px",
    textAlign: "center",
    fontFeatureSettings: "'cpsp' on",
    color: "rgba(0, 0, 0, 0.75)",
  },
  offerText: {
    margin: "auto",
    marginLeft: "8px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "16px",
    color: "#000000",
  },
  offerTextBox: {
    width: "130px",
    height: "36px",
    position: "relative",
    marginLeft: "8px",
  },
  offerIconBox: {
    position: "relative",
    background: "rgba(0, 0, 0, 0.9)",
    border: "1px solid #E1CAF2",
    width: "34px",
    height: "34px",
    borderRadius: "8px",
    margin: "0px",
    padding: "0px",
    float: "left",
  },
  offerIcon: {
    width: "24px",
    height: "auto",
    position: "relative",
    float: "left",
    margin: "12px 0px 0px 6px",
  },
  offerContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  signupError: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "21px",
    color: "red",
    marginTop: "15px",
  },
  rankContainer: {
    overflow: "hidden",
    position: "relative",
    width: "160px",
    height: "160px",
    margin: "30px 0px 0px 327px",
    borderRadius: "80px",
    borderWidth: "3px",
    borderColor: "red",
    background: "linear-gradient(to right, #E14084, #3454FA , #54B5BB)",
  },
  rankContainerInside: {
    width: "154px",
    height: "154px",
    background: "#fff",
    borderRadius: "79px",
    margin: "3px 0px 0px 3px",
  },
  rankHeadingText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    linHeight: "19px",
    margin: "45px 0px 0px 44px",
    color: "rgba(0, 0, 0, 0.9)",
    float: "left",
  },
  modalCloseButton: {
    cursor: "pointer",
    position: "relative",
    float: "right",
    padding: "24px 28px 0px 0px",
  },
  rankText: {
    position: "relative",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "36px",
    linHeight: "44px",
    margin: "0px 0px 0px 32px",
    color: "rgba(0, 0, 0, 0.9)",
    float: "left",
    textAlign: "center",
    background: "yellow",
    textTransform: "uppercase",
    background:
      "-webkit-linear-gradient(45deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  waitListDescription: {
    width: "631px",
    height: "81px",
    position: "relative",
    margin: "20px 0px 0px 91px",
  },
  waitListText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "27px",
    color: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  urlContainer: {
    padding: "2px 10px",
    width: "100%",
    maxWidth: "500px",
    height: "36px",
    border: "1px dashed rgba(0, 0, 0, 0.9)",
    borderRadius: "10px",
    position: "relative",
    margin: "24px auto 0",
    display: "flex",
    alignItems: "center",
  },
  bottomLink: {
    color: "#E14084",
    display: "block",
    marginTop: "10px",
    textAlign: "center",
  },
  urlText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  copyToClipboardContainer: {
    float: "right",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: "flex",
  },
  copyToClipboardButton: {
    cursor: "pointer",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    display: "flex",
  },
  copied: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
  },
  socialButtonsContainer: {
    position: "relative",
    margin: "36px 0px 0px 224px",
  },
  dashline: {
    width: "449px",
    margin: "36px 0px 0px 182px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
  },
  bottomText: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "21px",
    color: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  offerContainerBox: {
    position: "realtive",
    width: "703px",
    height: "101px",
    margin: "30px 0px 0px 54px",
    background: "url('/images/icons/bgEarlyAccessOffer.png')",
    borderRadius: "10px",
    color: "white",
    p: 4,
    padding: "0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    alignItems: "center",
    display: "flex",
    overflow: "hidden",
  },
  earlyAccessBox: {
    width: "176.78px",
    height: "172px",
    background: "linear-gradient(92deg, #626FD3 -6.99%, #8729BA 123.11%)",
    marginLeft: "-62px",
    borderRadius: "86px",
    overflow: "hidden",
  },
  earlyAccessText: {
    fontFamily: "Inter'",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "22px",
    margin: "56px 0px 0px 70px",
  },
  limitedOfferContainer: {
    width: "100%",
    height: "16px",
    background: "linear-gradient(90.78deg, #B237F6 3.91%, #E94177 96.03%)",
    alignItems: "center",
    display: "flex",
    marginTop: "10px",
  },
  limitedOfferText: {
    fontFamily: "Inter'",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "10px",
    margin: "0px 0px 0px 62px",
    lineHeight: "12px",
    paddingLeft: "8px",
  },
  buttonTitle: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#FFFFFF",
    textTransform: "none",
  },
  signupErrorContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "30px",
  },
  firstOfferLogoContainer: {
    width: "34px",
    height: "34px",
    background: "rgba(0, 0, 0, 0.9)",
    position: "relative",
    borderRadius: "8px",
  },
  secondOfferLogoContainer: {
    width: "34px",
    height: "34px",
    background: "#D4403A",
    border: "1px solid #E1CAF2",
    position: "relative",
    borderRadius: "8px",
  },
  secondLogo: {
    width: "23px",
    height: "auto",
    position: "relative",
    float: "left",
    margin: "6px 5px 6px 5px",
  },
  thirdOfferContainer: {
    width: "34px",
    height: "34px",
    background: "url(/images/icons/matic.png)",
    position: "relative",
    borderRadius: "8px",
  },
};

const OfferComponent = () => {
  return (
    <Box style={styles.offerContainer}>
      <Box sx={styles.offerIconBox}>
        <img src="./images/icons/matic.png" style={styles.offerIcon} />
      </Box>
      <Box style={styles.offerTextBox}>
        <Typography sx={styles.offerText}>
          MATIC worth upto 1.5 Lac(5000 users)
        </Typography>
      </Box>
    </Box>
  );
};

const TextField3 = withStyles({
  root: {
    "& label": {
      fontSize: "16px",
      color: "rgba(0, 0, 0, 0.54)",
    },
    "& label.Mui-focused": {
      color: "rgba(0, 0, 0, 0.54)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "black",
    },
    "& .MuiOutlinedInput-root": {
      color: "white",
      borderRadius: "12px",

      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.54)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(0, 0, 0, 0.54)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(0, 0, 0, 0.54)",
      },
    },
  },
})(TextField);

export default function EarlyAccessBtn(props) {
  const classes = useStyles();
  const [show, setShow] = useState(props.open);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = React.useState("");
  const [formErrors, setFormErrors] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isJoinedWaitList, setIsJoinedWaitList] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [refLink, setRefLink] = useState(null);
  const [signupError, setSignupError] = useState("");
  const [copied, setCopied] = useState(false);

  const { inviteCode } = useSelector((state) => state.home);

  useEffect(() => {
    console.log("InviteCode here is : ", inviteCode);
  }, [inviteCode]);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validateform = () => {
    const errors = {};
    const regex = /^[^s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const mobileregex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (!email) {
      errors.email = "Email id is required!";
      setFormErrors(errors);
      return false;
    } else {
      if (!validateEmail(email)) {
        errors.email = "Please enter valid email id!";
        setFormErrors(errors);
        return false;
      }
    }

    /* if (!mobile) {
      return true;
    } else if (!mobileregex.test(mobile)) {
      errors.mobile = "Please enter valid mobile no";
      setFormErrors(errors);
      return false;
    } else if (mobile.length > 10) {
      errors.mobile = "Mobile number must be 10 digits!";
      setFormErrors(errors);
      return false;
    } */

    return true;
  };

  const { mutate: sendVerificationEmail } = useMutation(
    (user) =>
      fetcher.post(`v1/auth/send-verification-email`, {
        user,
      }),
    {
      onSuccess: (res) => {
        console.log("sendVerificationEmail", res);
      },
    }
  );

  const joinWaitList = async (token) => {
    setSignupError("");
    let userObject = {
      name: "Default Name",
      email: email,
      password: "Password@123",
      role: "user",
      token: token,
    };
    if (inviteCode !== "" && typeof inviteCode !== "undefined") {
      userObject.referralCode = inviteCode;
    }

    if (mobile !== "") {
      userObject.mobile = mobile;
    }
    console.log(userObject);
    let response = await fetch("https://admin.artistfirst.in/v1/user", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userObject),
    });

    if (response.status == 201) {
      let data = await response.json();
      console.log("data joinWaitList", data);
      setIsJoinedWaitList(true);
      setRefLink(
        "https://stg1.artistfirst.in/invite/?inviteCode=" +
          data.referralId.refCode
      );
      sendVerificationEmail({ email: data.email, id: data.id });
      setUserDetails(data);
      console.log("userDetails", data);
    } else {
      let data = await response.json();
      setSignupError(data.message);
    }
  };
  //   error message

  // submit form function

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    console.log("Re Captcha token", token);
    if (email == "") {
      setFormErrors("Please enter valid email id!");
    }
    if (validateform()) {
      joinWaitList(token);
    }
  };

  // captha change
  const onCaptchaChange = (value) => {
    console.log("Captcha value:");
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 500);
    }
  }, [copied]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(refLink);
    setCopied(true);
  };

  return (
    <div>
      {/* <div className={classes.divStyle}>
        <input
          type="button"
          value="Sign Up For Early Access"
          onClick={handleShow}
          className={classes.btnStyle}
        />
      </div> */}
      <Button
        variant="contained"
        className={classes.btnStyle}
        onClick={handleShow}
      >
        Sign up for Early Access
      </Button>
      <Modal
        open={show}
        onClose={handleClose}
        // aria-labelledby="modal-modal-title"
        // aria-describedby="modal-modal-description"
        // className= {classes.modal}
      >
        <>
          {isJoinedWaitList ? (
            <div style={{ widht: "100%", height: "100%" }}>
              <Box sx={style}>
                <Box
                  sx={styles.modalCloseButton}
                  onClick={handleClose}
                  position="absolute"
                >
                  <MdOutlineClose size={24} color="#000000" />
                </Box>

                <Box sx={styles.rankContainer}>
                  <div style={styles.rankContainerInside}>
                    <Typography sx={styles.rankHeadingText}>
                      Waitlist
                    </Typography>
                    <Typography sx={styles.rankText}>
                      {userDetails ? userDetails.userRank : ""}
                    </Typography>
                  </div>
                </Box>
                <Box sx={styles.waitListDescription}>
                  <Typography sx={styles.waitListText}>
                    Verify your email to receive upto INR 100 worth crypto.
                  </Typography>
                  <Typography
                    sx={{ ...styles.waitListText, fontWeight: "400" }}
                  >
                    Receive additional rewards for successful referrals. Use
                    thebelow link to refer your friends.
                  </Typography>
                </Box>
                <Box sx={styles.urlContainer}>
                  <a href={refLink}>
                    <Typography sx={styles.urlText}>{refLink}</Typography>
                  </a>
                  <Box sx={styles.copyToClipboardContainer}>
                    <Box
                      sx={styles.copyToClipboardButton}
                      onClick={copyToClipboard}
                    >
                      {copied ? (
                        <Typography variant="h5" sx={styles.copied}>
                          Copied
                        </Typography>
                      ) : (
                        <IoCopyOutline size={24} color="#E14084" />
                      )}
                    </Box>
                  </Box>
                </Box>
                <Box sx={styles.dashline}></Box>
                <Box sx={styles.socialButtonsContainer}>
                  <SocialShareComponent shareLink={refLink} />
                </Box>
                <Box
                  sx={{
                    position: "relative",
                    margin: "36px 0px 0px 69px",
                    width: "675px",
                    height: "42px",
                  }}
                >
                  <Typography variant="h5" sx={styles.bottomText}>
                    For even more updates, contests and giveaways, follow us on
                    discord and other social media.
                  </Typography>
                  <Link href="javascript:void(0)" sx={styles.bottomLink}>
                    Refresh Status
                  </Link>
                </Box>
              </Box>
            </div>
          ) : (
            <>
              {/* <div style={{ widht: "100%", height: "100%" }}>
              <Box sx={style}>
                <div className={classes.heading}>
                  <Typography variant="h5" sx={styles.headingText}>
                    Join Waitlist
                  </Typography>
                </div>
                <div className={classes.description}>
                  <Typography variant="p" sx={styles.descriptionText}>
                    Be among the top 20000 inviters to get an exclusive FanTiger
                    airdrop
                  </Typography>
                </div>

                <Box sx={styles.offerContainerBox}>
                  <div style={styles.earlyAccessBox}>
                    <Typography style={styles.earlyAccessText}>
                      EARLY ACCESS
                    </Typography>
                    <Box style={styles.limitedOfferContainer}>
                      <Typography style={styles.limitedOfferText}>
                        Limited Period Offer
                      </Typography>
                    </Box>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "9.5px",
                    }}
                  >
                    <div style={styles.offerContainer}>
                      <div style={styles.firstOfferLogoContainer}>
                        <img
                          src="/images/icons/boat.png"
                          style={styles.offerIcon}
                        />
                      </div>

                      <p style={{ ...styles.offerText, width: "106px" }}>
                        10,000 Discount vouchers for Boat Headphones
                      </p>
                    </div>

                    <div
                      style={{ ...styles.offerContainer, marginLeft: "30px" }}
                    >
                      <div style={styles.secondOfferLogoContainer}>
                        <img
                          src="/images/icons/gaana.png"
                          style={styles.secondLogo}
                        />
                      </div>

                      <Typography
                        style={{ ...styles.offerText, width: "145px" }}
                      >
                        5000 Gaana vouchers for 1 month subscription
                      </Typography>
                    </div>
                    <div
                      style={{
                        ...styles.offerContainer,
                        marginLeft: "30px",
                      }}
                    >
                      <div style={styles.thirdOfferContainer}></div>

                      <p style={{ ...styles.offerText, width: "130px" }}>
                        MATIC worth upto ₹1.5 Lac (5000 users)
                      </p>
                    </div>
                  </div>
                </Box>

                <div className={classes.paper}>
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={handleClose}
                    top={0}
                    right={0}
                    position="absolute"
                  >
                    <MdOutlineClose size={24} />
                  </Box>
                </div>

                <form onSubmit={handleSubmit} validate autoComplete="off">
                  <TextField3
                    error={formErrors.email}
                    helperText={formErrors.email}
                    id="userName"
                    label="Email id"
                    value={email}
                    onChange={(e) => {
                      setSignupError("");
                      setEmail(e.target.value);
                    }}
                    name="email"
                    inputProps={{ className: classes.input }}
                    className={classes.textField}
                    type={"email"}
                  />

                  <TextField3
                    error={formErrors.mobile}
                    helperText={formErrors.mobile}
                    id="mobile"
                    label="Mobile No (Optional)"
                    value={mobile}
                    onChange={(e) => {
                      setSignupError("");
                      setMobile(e.target.value);
                    }}
                    name="mobile no"
                    inputProps={{ className: classes.input }}
                    className={classes.mobileTextField}
                    type="tel"
                  />

                  <div style={styles.signupErrorContainer}>
                    {signupError && (
                      <p style={styles.signupError}>{signupError}</p>
                    )}
                  </div>

                  <p className={classes.conditonPara}>
                    By signing up, you are agree to the{" "}
                    <a href="#" className={classes.termscondition}>
                      {" "}
                      Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a href="#" className={classes.termscondition}>
                      Privacy Policy{" "}
                    </a>
                    and to receive updates from FanToger
                  </p>

                  <Gradient
                    type="submit"
                    value="Submit"
                    variant="contained"
                    color="primary"
                    text="I agree"
                    className={classes.signbtn}
                  >
                    <Typography style={styles.buttonTitle}>
                      Join Waitlist
                    </Typography>
                  </Gradient>
                </form>
              </Box>
            </div> */}
              <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                  <button
                    type="button"
                    className="close clse-btn"
                    aria-label="Close"
                    onClick={(e) => handleClose(e)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div className="title01 mx-auto d-block">
                    <h5 className="modal-title01" id="exampleModalLongTitle">
                      Join Early Access Waitlist
                    </h5>
                  </div>
                  <div className="join-waitlist-img">
                    <h3>Get a Limited Edition</h3>
                    <h2 className="txt-gradient">FanTiger NFT</h2>
                  </div>
                  <form onSubmit={handleSubmit} noValidate autoComplete="off">
                    <div className="join-wait-form">
                      <div className="title02 mx-auto d-block">
                        <p>
                          Top 5,000 inviters to get a Limited Edition FanTiger
                          NFT
                        </p>
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            id="exampleInputEmail1"
                            aria-describedby="emailHelp"
                            placeholder="Email Id"
                            value={email}
                            onChange={(e) => {
                              setSignupError("");
                              setEmail(e.target.value);
                            }}
                            name="email"
                          />
                          {formErrors?.email && (
                            <span style={{ color: "red" }}>
                              {formErrors.email}
                            </span>
                          )}
                        </div>
                      </div>
                      <div style={styles.signupErrorContainer}>
                        {signupError && (
                          <p style={styles.signupError}>{signupError}</p>
                        )}
                      </div>
                      <div className="form-group mx-auto d-block">
                        <p className="form-check-label">
                          By signing up, you are agree to the{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => window.open("/terms", "_blank")}
                          >
                            Terms & Conditions{" "}
                          </span>
                          and{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => window.open("/privacy", "_blank")}
                          >
                            Privacy Policy{" "}
                          </span>
                          and to receive updates from FanTiger
                        </p>
                        {/*  <input type="checkbox" className="form-check-input" id="exampleCheck1"/> */}
                      </div>
                      <div className="join-modal-footer01 mx-auto d-block">
                        <button type="submit" className="btn">
                          Join Waitlist
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
        </>
      </Modal>
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey="6LfV-WQfAAAAAA-jbkxkgzShlqBU6zImg4MZp05d"
        onChange={onCaptchaChange}
      />
    </div>
  );
}
